/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { useEventsList } from '@api/hooks';
import { formatWASEventName } from '@utils/event';

import SearchableEntitySelect from '../SearchableEntitySelect';

const EventFormItem = React.forwardRef(({ placeholder = 'Type to search event', children, ...props }, ref) => (
  <SearchableEntitySelect
    ref={ref}
    placeholder={placeholder}
    useList={useEventsList}
    formatLabel={formatWASEventName}
    {...props}
  />
));

export default EventFormItem;
